<template>
  <div class="lview">
    <div class="lview__scroll">
      <div class="lview__head">
        <span class="lc lc--title">{{ $t('taskDeskTaskName') }}</span>
        <span class="lc lc--status">{{ $t('taskDeskStatus') }}</span>
        <span class="lc lc--person">{{ $t('functor') }}</span>
        <span class="lc lc--people">{{ $t('participants') }}</span>
        <span class="lc lc--date">{{ $t('start-date') }}</span>
        <span class="lc lc--date">{{ $t('due-date') }}</span>
        <span class="lc lc--act" />
      </div>
      <section v-for="g in groups" :key="g.col.id" class="lgroup" :style="{ '--cc': g.col.color || '#9aa4b2' }">
        <button type="button" class="lgroup__head" @click="toggle(g.col.id)">
          <v-icon small class="lgroup__chev" :class="{ 'lgroup__chev--closed': closed[g.col.id] }">
            mdi-chevron-down
          </v-icon>
          <span class="lgroup__dot" />
          <span class="lgroup__name">{{ g.col.name }}</span>
          <span class="lgroup__count">{{ g.col.total || 0 }}</span>
          <v-spacer />
          <span
            class="lgroup__add"
            role="button"
            :title="$t('task')"
            @click.stop="desk.openCreateTask('task', null, g.col, desk.template)"
          >
            <v-icon small>mdi-plus</v-icon>
          </span>
        </button>
        <template v-if="!closed[g.col.id]">
          <div
            v-for="t in g.tasks"
            :key="t.key"
            class="lrow"
            :class="{ 'lrow--done': t.done }"
            @click="desk.editTask('task', t.el.ref)"
          >
            <span class="lc lc--title">
              <span class="lrow__title">{{ t.el.ref.title }}</span>
              <span v-for="(tag, i) in (t.el.ref.tags || []).slice(0, 3)" :key="i" class="lrow__tag" :style="{ background: tag.color }">
                {{ tag.text }}
              </span>
            </span>
            <span class="lc lc--status" @click.stop>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <button type="button" class="lrow__status" :style="{ '--sc': t.col.color }" v-on="on">
                    {{ t.col.name }}
                    <v-icon x-small>mdi-chevron-down</v-icon>
                  </button>
                </template>
                <v-list dense>
                  <v-subheader>{{ $t('taskDeskMoveTo') }}</v-subheader>
                  <v-list-item
                    v-for="c in desk.columns"
                    :key="c.id"
                    :disabled="c.id === t.col.id"
                    @click="desk.moveTo(t, c)"
                  >
                    <span class="lrow__menu-dot" :style="{ background: c.color }" />
                    <v-list-item-title>{{ c.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
            <span class="lc lc--person">{{ t.el.ref.functor ? t.el.ref.functor.name : '—' }}</span>
            <span class="lc lc--people">
              <span
                v-for="(p, i) in (t.el.ref.participants || []).slice(0, 4)"
                :key="i"
                class="lrow__avatar"
                :style="{ background: (p.user && p.user.color) || '#90a4ae' }"
                :title="p.user ? p.user.firstname + ' ' + (p.user.lastname || '') : ''"
              >
                <img v-if="p.user && p.user.avatar" :src="p.user.avatar.link" alt="">
                <template v-else-if="p.user">{{ p.user.firstname.charAt(0) }}</template>
              </span>
            </span>
            <span class="lc lc--date">{{ fmtDate(t.start, t.el.ref.due_date) }}</span>
            <span class="lc lc--date" :class="{ 'lrow__late': isLate(t) }">{{ fmtDate(t.end, t.el.ref.due_end_date) }}</span>
            <span class="lc lc--act" @click.stop>
              <button v-if="!t.done" type="button" class="lrow__btn lrow__btn--ok" :title="$t('setDone')" @click="desk.setDoneStatus(t.el.ref)">
                <v-icon x-small>mdi-check</v-icon>
              </button>
              <button type="button" class="lrow__btn" :title="$t('copy')" @click="desk.copyTask('task', t.el.ref)">
                <v-icon x-small>mdi-content-copy</v-icon>
              </button>
              <button type="button" class="lrow__btn lrow__btn--del" :title="$t('remove')" @click="desk.askDelete(t.el.ref)">
                <v-icon x-small>mdi-trash-can-outline</v-icon>
              </button>
            </span>
          </div>
          <div v-if="!g.tasks.length" class="lrow lrow--empty">{{ $t('taskDeskEmpty') }}</div>
          <button v-if="desk.hasMore(g.col)" type="button" class="lgroup__more" @click="desk.getTask(g.col)">
            {{ $t('taskDeskLoadMore') }}
          </button>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import { today, fmt } from '../deskDates'

export default {
  name: 'ListView',
  inject: ['desk'],
  data () {
    return { closed: {} }
  },
  computed: {
    groups () {
      return this.desk.columns.map(col => ({
        col,
        tasks: this.desk.tasks.filter(t => t.col === col),
      }))
    },
  },
  methods: {
    toggle (id) {
      this.$set(this.closed, id, !this.closed[id])
    },
    fmtDate (m, raw) {
      if (!raw) return '—'
      return m ? fmt(m, 'D MMM YYYY', this.desk.jalali) : raw
    },
    isLate (t) {
      return !t.done && t.end && t.end.isBefore(today())
    },
  },
}
</script>

<style scoped>
.lview {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  overflow: hidden;
}
.theme--dark .lview {
  background: #1e1e1e;
  border-color: #333;
}
.lview__head,
.lrow {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 150px 140px 120px 110px 110px 96px;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
}
.lview__head {
  position: sticky;
  top: 0;
  z-index: 2;
  min-width: 980px;
  height: 40px;
  font-size: 0.75rem;
  color: #8a94a6;
  background: #f8f9fb;
  border-bottom: 1px solid #e6e9ef;
}
.theme--dark .lview__head {
  background: #191919;
  border-color: #333;
}
.lview__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
.lc {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lgroup__head {
  position: sticky;
  top: 40px;
  z-index: 1;
  width: 100%;
  min-width: 980px;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 10px;
  background: #fbfcfd;
  border-bottom: 1px solid #eef0f4;
  border-inline-start: 3px solid var(--cc);
  font-size: 0.85rem;
}
.theme--dark .lgroup__head {
  background: #222;
  border-color: #333;
}
.lgroup__chev {
  transition: transform 0.15s;
}
.lgroup__chev--closed {
  transform: rotate(90deg);
}
.v-application--is-rtl .lgroup__chev--closed {
  transform: rotate(-90deg);
}
.lgroup__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--cc);
}
.lgroup__name {
  font-weight: 700;
}
.lgroup__count {
  font-size: 0.72rem;
  padding: 0 7px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.06);
}
.lgroup__add {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.lgroup__add:hover {
  background: rgba(0, 0, 0, 0.07);
}
.lgroup__more {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 0.8rem;
  color: var(--v-primary-base);
  border-bottom: 1px solid #eef0f4;
}
.lrow {
  min-width: 980px;
  min-height: 46px;
  border-bottom: 1px solid #f0f2f5;
  font-size: 0.82rem;
  cursor: pointer;
}
.theme--dark .lrow {
  border-color: #2a2a2a;
}
.lrow:hover {
  background: #f7f9fc;
}
.theme--dark .lrow:hover {
  background: #252525;
}
.lrow--empty {
  display: block;
  line-height: 46px;
  color: #9aa4b2;
  cursor: default;
}
.lrow--done .lrow__title {
  color: #8a94a6;
  text-decoration: line-through;
}
.lrow__title {
  font-weight: 600;
  margin-inline-end: 6px;
}
.lrow__tag {
  display: inline-block;
  font-size: 0.66rem;
  line-height: 17px;
  padding: 0 6px;
  border-radius: 4px;
  color: #fff;
  margin-inline-end: 3px;
}
.lrow__status {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 0.74rem;
  color: var(--sc);
  border: 1px solid var(--sc);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lrow__status .v-icon {
  color: inherit;
}
.lrow__menu-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-inline-end: 10px;
}
.lrow__avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-inline-start: -6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 0.62rem;
  color: #fff;
  vertical-align: middle;
}
.lrow__avatar:first-child {
  margin-inline-start: 0;
}
.lrow__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.lrow__late {
  color: #c2185b;
  font-weight: 600;
}
.lc--act {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s;
}
.lrow:hover .lc--act {
  opacity: 1;
}
.lrow__btn {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.lrow__btn:hover {
  background: #eef1f6;
}
.lrow__btn .v-icon {
  color: #6b7280;
}
.lrow__btn--ok .v-icon {
  color: #2e7d32;
}
.lrow__btn--del .v-icon {
  color: #d81b60;
}
</style>
